import { create } from 'zustand';

/** Which view the shared sidebar shows. */
export type SidebarTab = 'resources' | 'agents';

// Open state for the widget's documents/agents sidebar, shared across the chat tree (the toggle in
// the widget header, the slot that sizes for it, the resource markers that open it, and the composer
// "N running" indicator that opens straight to the agents tab). In-memory so it survives route
// changes; resets on reload.
type DocumentsPanelState = {
  isOpen: boolean;
  tab: SidebarTab;
  /** A background-agent id to open straight into its transcript (consumed + cleared by the panel). */
  agentTarget: string | null;
  open: () => void;
  close: () => void;
  toggle: () => void;
  setTab: (tab: SidebarTab) => void;
  /** Open the sidebar directly on a given tab (agents-list, no specific transcript). */
  openTo: (tab: SidebarTab) => void;
  /** Open the Background-agents sidebar directly on a specific sub-agent's transcript. */
  openAgent: (agentId: string) => void;
  clearAgentTarget: () => void;
};
const useStore = create<DocumentsPanelState>(set => ({
  isOpen: false,
  tab: 'resources',
  agentTarget: null,
  open: () => set({
    isOpen: true
  }),
  close: () => set({
    isOpen: false
  }),
  toggle: () => set(state => ({
    isOpen: !state.isOpen
  })),
  setTab: tab => set({
    tab
  }),
  openTo: tab => set({
    isOpen: true,
    tab,
    agentTarget: null
  }),
  openAgent: agentId => set({
    isOpen: true,
    tab: 'agents',
    agentTarget: agentId
  }),
  clearAgentTarget: () => set({
    agentTarget: null
  })
}));

/** Open/closed + active-tab state for the chat widget's sidebar. */
const useDocumentsPanelOpen = () => {
  return useStore();
};
export default useDocumentsPanelOpen;